import { Avatar, Box, Flex, Typography } from "../../../ppui";
import { formatIndianCurrency } from "../../../utils/common";

export const SalaryHeaders = [
  { key: "salary_id", label: "SL", isShortable: true, isVisible: true, getValue: (row, index) => (index + 1) },
  {
    key: "employee_name",
    label: "Employee Name",
    align: "left",
    isClickable: true,
    isShortable: true,
    isVisible: true,
    getValue: (SalaryRows) => <>
      <Flex alignItems="center" >
        <Avatar
          className={"avatarHover"}
          size="xs"
          color="secondary"
          initials={`${SalaryRows.employee_name.trim().substring(0, 1).toUpperCase()}`}
          sx={{ marginInlineEnd: "0.625rem" }}
        />
        <Box color={"secondary"}>
          {SalaryRows.employee_name}
          <Typography
            color={"default"}
            colorVariant={"light"}
            variant={"body3"}
            mb={"0"}
          >
            #{SalaryRows?.employee_code}
          </Typography>
        </Box>
      </Flex>
    </>,
  },
  // {
  //   key: `designation`,
  //   label: "Designation",
  //   isShortable: true,
  //   isVisible: true,
  //   isColumnSticky: "true",
  //   getValue: (SalaryRows) => {
  //     SalaryRows?.employees?.designation
  //   },
  // },

  // {
  //   key: "amountDrawnAs",
  //   label: "Amount Drawn As",
  //   align: "left",
  //   isShortable: false,
  //   isVisible: true,
  // },

  {
    key: "month_days",
    label: "Month days",
    align: "left",
    isShortable: false,
    isVisible: true,
  },

  {
    key: "payable_days",
    label: "Payable Days",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => (row?.payable_days ? row?.payable_days : "0")
  },

  {
    key: "ncp_days",
    label: "NCP days",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => (row?.ncp_days ? row?.ncp_days : "0")
  },
  {
    key: "totalearning",
    label: "Total Earnings (₹)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => formatIndianCurrency(Number(row?.gross_salary.toFixed()) )
  },

  {
    key: "deduction",
    label: "Total Deduction (₹)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => formatIndianCurrency(Math.round(Number(row?.total_deduction)))
  },
  {
    key: "payable_salary",
    label: "Net Payable (₹)",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => formatIndianCurrency(Math.round(Number(row?.payable_salary)))
  },

];

export const SalaryRows = [
  {
    slNo: 1,
    employeeName: "Barun Sharma",
    employee_code: "Pia002",
    designation: "IT",
    amountDrawnAs: "Salaried",
    monthDays: "31",
    payableDays: "31",
    presentDays: "23",
    earning: "₹35,000",
    deduction: "₹1,950",
    netpayable: "33,050",
  },


];

